import { render, staticRenderFns } from "./edit-promotional.vue?vue&type=template&id=1d2d649e&"
import script from "./edit-promotional.vue?vue&type=script&lang=js&"
export * from "./edit-promotional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports